import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import RegisterPage from './pages/RegisterPage';
import AdminLoginPage from './pages/AdminLoginPage';
import DashboardCliente from './pages/DashboardCliente';
import AdminDashboard from './pages/AdminDashboard';
import OperatingHoursAdmin from './pages/OperatingHoursAdmin';
import MaterialsAdmin from './pages/MaterialsAdmin';
import BookingPage from './pages/BookingPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/admin-login" element={<AdminLoginPage />} />
        <Route path="/dashboard-cliente" element={<DashboardCliente />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/admin-operating-hours" element={<OperatingHoursAdmin />} />
        <Route path="/admin-materials" element={<MaterialsAdmin />} />
        <Route path="/prenota-carico" element={<BookingPage />} />
        <Route path="/prenota-scarico" element={<BookingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
